module.exports = __webpack_public_path__ + "img/BridgestoneFooter.5f1a5bca.png";